<template>
  <div>
    <div class="author-card">
      <md-avatar class="md-large">
        <img :src="user.avatar" :alt="name" />
      </md-avatar>

      <div class="author-card-info">
        <span>
          <b>{{ this.name }}</b>
        </span>
        <span>{{ this.user.email }}</span>
      </div>
    </div>
    <div>
      <div style="float: right;">
        <md-button @click="signOut" class="md-dense md-raised md-accent">Sign out</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Profile",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: s => s.auth.user,
      name: s => s.auth.user.first_name + " " + s.auth.user.last_name
    })
  },
  methods: {
    ...mapActions(["signOut"])
  }
};
</script>
<style lang="scss">
.author-card {
  padding: 8px 16px;
  display: flex;
  align-items: center;

  .md-avatar {
    margin-right: 16px;
  }

  .author-card-info {
    display: flex;
    flex-flow: column;
    flex: 1;
  }

  span {
    font-size: 16px;
  }

  .author-card-links {
    display: flex;

    a + a {
      margin-left: 8px;
    }
  }
}
</style>
